import type { Context } from 'react';
import { createContext } from 'react';

export const ContainerWidthContext: Context<number> = createContext<number>(Infinity);
